<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Motifs d'appels</h1>
                <div class="pageOptions">
                    <btn text="Ajouter" ico="add" @click="add()" v-if="$store.getters.hasPerm('reason:add/edit')"></btn>
                </div>
            </div>
            <search-bar @search="search" :value="filter" :show-active="true" @activeChange="activeChange" :active="activeOnly"></search-bar>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                <tr>
                    <th>
                        Libellé
                        <table-order name="label" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Observation
                        <table-order name="observation" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Options
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(reason, key) in visibles">
                    <td>{{reason.label}}</td>
                    <td>{{reason.observation}}</td>
                    <td class="tableOptions">
                        <div @click="edit(reason.id)"
                             v-if="$store.getters.hasPerm('reason:add/edit')" title="Modifier le motif d'appel">
                            <svg class="option">
                                <use xlink:href="#icon-edit"></use>
                            </svg>
                        </div>
                        <label class="switch" v-if="$store.getters.hasPerm('reason:active')" :title="(reason.active == 0 ? 'Activer':'Désactiver') + ' le motif d\'appel' ">
                            <input type="checkbox" @change="active(reason, $event)" :checked="reason.active == 1">
                            <span class="slider"></span>
                        </label>
                    </td>
                </tr>
                <tr v-if="visibles.length <= 0">
                    <td colspan="3" style="text-align: center">Il n'y a aucun motif d'appel</td>
                </tr>
                </tbody>
            </table>
            <pagination :current="currentPage" :limit="limit" :array="filters" @change="pageChange"
                        @limitChange="limitChange"></pagination>
        </div>
    </div>
</template>

<script>
    import SearchBar from "@/components/SearchBar";
    import Pagination from "@/components/Pagination";
    import Loader from "@/components/Loader";
    import TableOrder from "@/components/TableOrder";
    import axios from 'axios';
    import tools from '../config.ts';
    import Btn from "@/components/Btn";

    export default {
        name: "Reasons",
        components: {Btn, Pagination, SearchBar, Loader, TableOrder},
        data() {
            return {
                currentPage: 0,
                limit: 100,
                filter: "",
                order: {
                    order: 'asc',
                    name: 'label',
                },
                activeOnly:true,
                reasons: [],

                locals: ["reasons", "currentPage", "filter", "order"],
                cookies: ["limit"],
            }
        },
        methods: {
            load() {
                axios.get(tools.api("reasons"), tools.headerGET())
                    .then((response) => {
                        this.reasons = response.data;

                        tools.loader(false);
                        tools.saveLocals("reasons", this);
                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            add() {
                this.$router.push("reason")
            },
            edit(reasonId) {
                this.$router.push("reason/" + reasonId)
            },
            active(reason, $event) {

                let active = $event.target.checked;

                if (!active) {
                    tools.popup("confirm", {
                        message: "Voulez-vous vraiment désactiver ce motif d'appel '" + reason.label + "' ?<br/>Il ne sera plus disponible pour aucun client",
                        success: () => {
                            this.activeRequest(reason, active, $event);
                        }, error: () => {
                            $event.target.checked = true;
                        }
                    })
                } else {
                    tools.popup("confirm", {
                        message: "Voulez-vous vraiment activer ce motif d'appel '" + reason.label + "' ?<br/>Il sera disponible pour tous les clients ayant déjà se motif d'activé précédement",
                        success: () => {
                            this.activeRequest(reason, active, $event);
                        }, error: () => {
                            $event.target.checked = false;
                        }
                    })

                }
            },
            activeRequest(reason, active, $event) {
                axios.get(tools.api("reason/" + reason.id + "/toggle/" + (active ? "1" : "0")), tools.headerGET())
                    .then((response) => {
                        if (!tools.isSuccessResponse(response)) {
                            $event.target.checked = !active;
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de " + (active ? "l'activation" : "la désactivation") + " du motif d'appel.",
                            });
                        }

                        this.load();
                    })
                    .catch((error) => {
                        $event.target.checked = !active;
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de la désactivation du motif d'appel. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })
            },
            limitChange(limit) {
                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("reasons", this);
            },
            pageChange(page) {
                this.currentPage = page

                tools.saveLocals("reasons", this);
            },
            search(filter) {
                this.filter = filter;

                tools.saveLocals("reasons", this);
            },
            changeOrder(data) {
                this.order = {
                    order: data.order,
                    name: data.name
                }
                tools.saveLocals("reasons", this);
            },
            activeChange(val){
                if(val === "all") this.activeOnly = false;
                else this.activeOnly = true;
            }
        },
        computed: {
            filters() {

                let reasons = this.reasons;

                if (this.filter) {
                    // console.log(this.filter)
                    let reg = new RegExp(this.filter, "i");
                    reasons = reasons.filter((reason) => reg.exec(reason.label) || reg.exec(reason.observation))
                }

                if(this.activeOnly){
                    reasons = reasons.filter((reason) => reason.active === "1")
                }

                tools.sortArray(reasons, this.order)

                return reasons;
            },
            visibles() {
                return this.filters.slice(this.currentPage * this.limit, (this.currentPage * this.limit) + parseInt(this.limit));
            }
        },
        mounted() {

            if (!this.$store.getters.hasPerm('reason:list')) {
                return this.$router.back();
            }

            tools.setLocals("reasons", this);
            tools.setCookies("reasons", this);

            tools.$emit("orderChange", this.order);

            tools.loader(true);
            this.$store.commit("onEditMode", false);

            this.load();
        }
    }
</script>
